<template>
	<div class="question-container QuestionAutoComplete">
		<div>
			<div
				:class="{
					'question-text': true,
					'hide-question-text': hideQuestionText,
				}"
				v-for="(question, index) in data.question.getQuestion()"
				v-html="question"
				:key="index"
			></div>
			<div
				class="note-text"
				:style="{ color: theme.lightMainTextColor }"
				v-for="(note, index) in data.question.getNotes()"
				v-html="note"
				:key="index + 100"
			></div>
			<div class="input-text">
				<div
					:style="{
						color: v$.textValue.$invalid ? theme.errorInputAccentColor : theme.mainTextColor,
					}"
				>
					<AutocompleteComponent
						:data="dropdownDataList"
						:searchKeys="['description']"
						mainKey="description"
						@change="searchTextChanged"
						@blur="onBlurHandler"
						@focus="onFocusHandler"
						@selected="saveValueSelected"
						placeholder="Enter Address..."
						:invalid="v$.textValue.$invalid"
						:clearOnSelect="true"
						:preSelected="preSelectedValue"
						ref="autocomplete"
						autocomplete="off"
					>
						<!--:autofocus="textValue ? false : true">-->
					</AutocompleteComponent>
				</div>
			</div>
		</div>
		<div class="question-continue-button">
			<button
				class="continue button"
				:style="{
					background: theme[answer.style.background],
					color: theme[answer.style.text],
				}"
				@click="answer.actions(textValue, [selectedObject], data.question, toggleLoading, saveApplicationAction)"
				:disabled="!data.question.isValidationsMet(answer, v$.textValue)"
			>
				{{ data.question.getLocalizationDisplay(answer.label, data.language) }}
			</button>
		</div>
	</div>
</template>

<script>
	import AutocompleteComponent from '@/components/customerApp/AutocompleteComponent.vue';
	import * as ApplicationsSettingsDropdowns from '@core/classes/Applications/ApplicationsSettingsDropdowns';
	import * as ApplicationsSettingsAPIs from '@core/classes/Applications/ApplicationsSettingsAPIs';
	import { useVuelidate } from '@vuelidate/core';

	export default {
		name: 'QuestionAutoComplete',
		props: ['theme', 'data', 'questionKey', 'toggleLoading', 'saveApplicationAction'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				answer: {},
				textValue: null,
				dropdownDataList: [],
				searchText: null,
				preSelectedValue: null,
				selectedObject: null,
				hideQuestionText: false,
			};
		},
		computed: {},
		created() {
			this.answer = this.data.question.getAnswers()[0];
			this.init(this.data.question.savedAnswer);
			this.$watch(
				() => this.data.language,
				newValue => {
					this.data.question.customerApp().quoteAppData.changeLanguage(newValue);
				},
				{ deep: true },
			);
			this.$watch(
				() => this.$props,
				() => {
					this.init(this.data.question.savedAnswer);
				},
				{ deep: true },
			);
		},

		validations() {
			if (this.data.question.GetValidation) {
				return this.data.question.GetValidation();
			}
		},
		methods: {
			async searchTextChanged(searchedText) {
				this.searchText = searchedText;
				if (this.data.question.dropdown.callMethodOnChange) {
					const { listMethod, keys } = this.data.question.dropdown;
					this.dropdownDataList = await ApplicationsSettingsDropdowns[listMethod](keys, this.data.language, this.data.application, this.searchText);
				}
			},
			async saveValueSelected(value) {
				this.selectedObject = value;
				if (this.data.question.dropdown.onSelectApiMethod) {
					const newValue = await ApplicationsSettingsAPIs[this.data.question.dropdown.onSelectApiMethod](
						this.textValue,
						[this.selectedObject],
						this.data.question,
						this.data.application,
						this.searchText,
					);
					this.init(newValue ?? this.selectedObject.description);
				} else {
					this.init(this.selectedObject.description);
				}
			},
			init(address) {
				this.preSelectedValue = { description: address };
				this.dropdownDataList.push(this.preSelectedValue);
				this.textValue = address;
			},
			onBlurHandler() {
				if (this.data.question.dropdown.callMethodOnChange) {
					this.dropdownDataList = [];
				}
				this.init(this.preSelectedValue.description);
				this.hideQuestionText = false;
			},
			onFocusHandler() {
				this.hideQuestionText = true;
			},
		},
		components: {
			AutocompleteComponent,
		},
	};
</script>

<style>
	.QuestionAutoComplete .dropdown-container {
		cursor: pointer;
		position: relative;
		z-index: 9999;
	}

	.QuestionAutoComplete .dropdown {
		color: black !important;
		width: 100% !important;
		position: absolute;
	}

	.QuestionAutoComplete .dropdown .list-container {
		border: 1px solid #000;
		padding: 5px 20px;
		background: white;
		max-height: 350px;
		overflow-y: auto;
	}

	.QuestionAutoComplete .dropdown .list-container ul {
		list-style: none;
	}

	.QuestionAutoComplete .dropdown .list-container ul li {
		font-size: 1.2rem;
		font-weight: 500;
		z-index: 9999;
	}

	.QuestionAutoComplete .dropdown .list-container ul li.list-item {
		box-shadow: inset -1px -1px 0px 2px rgb(0 0 0 / 3%);
		padding: 16px;
		margin: 12px 0;
		border-radius: 10px;
	}

	.QuestionAutoComplete .dropdown .list-container ul li:hover {
		background-color: #ddd;
	}

	@media only screen and (max-width: 1024px) {
		.question-text.hide-question-text {
			display: none;
		}

		.question-text.hide-question-text + .input-text {
			margin-top: 60px;
		}
	}

	@media only screen and (min-width: 1024px) {
		.QuestionAutoComplete .dropdown .list-container {
			max-height: unset;
		}
	}
</style>
